export default __webpack_public_path__ + "static/N0228-89479caf6d9b09c01df2dfd9c255f54e.png";